import { Navigation, Pagination } from 'swiper/modules';
import { addSlider } from '../helpers';

/**
 * DomReady
 *
 * @param {Function} callback
 */
const domReady = callback => {
	if ( document.readyState === 'interactive' || document.readyState === 'complete' ) {
		return callback();
	}

	document.addEventListener( 'DOMContentLoaded', callback );
};

domReady( () => {
	const presets = {
		productCarousel: {
			modules: [ Navigation ],
			direction: 'horizontal',
			createElements: true,
			slidesPerView: 'auto',
			loop: true,
			watchSlidesProgress: true,
			threshold: 1,
			navigation: {
				nextEl: '.slider-arrow--next',
				prevEl: '.slider-arrow--prev',
				closest: '.container',
			},
		},
		bulletSlider: {
			modules: [ Pagination ],
			direction: 'horizontal',
			createElements: true,
			slidesPerView: 'auto',
			watchSlidesProgress: true,
			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: true,
			},
			allowTouchMove: true,
			setWrapperSize: true,
		},
	};

	const sliders = {};

	sliders.popularProducts = addSlider(
		'.popular-products-slider',
		presets.productCarousel
	);

	sliders.productsCarousels = addSlider(
		'.products-slider',
		presets.productCarousel
	);

	sliders.bestSellers = addSlider(
		'.wc-block-product-best-sellers',
		presets.productCarousel
	);

	( () => {
		const settings = {
			...presets.bulletSlider,
			setWrapperSize: false,
		};

		sliders.gridSlider = [
			...addSlider( '.slider-container-m', settings ),
			...addSlider( '.slider-container-s', settings ),
		];
	} )();
} );
